export function touchHandler(event: any) {
  const touches = event.changedTouches;
  const first = touches[0];
  let type = '';

  switch (event.type) {
    case 'touchstart': type = 'mousedown'; break;
    case 'touchmove': type = 'mousemove'; break;
    case 'touchend': type = 'mouseup'; break;
    default: return;
  }

  // initMouseEvent(type, canBubble, cancelable, view, clickCount,
  //                screenX, screenY, clientX, clientY, ctrlKey,
  //                altKey, shiftKey, metaKey, button, relatedTarget);

  const simulatedEvent = document.createEvent('MouseEvent');
  simulatedEvent.initMouseEvent(type, true, true, window, 1,
    first.screenX, first.screenY,
    first.clientX, first.clientY, false,
    false, false, false, 0/* left */, null);

  first.target.dispatchEvent(simulatedEvent);

  // touchevent가 실행되는 곳에서 에러 발생
  // [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive.
  // 클릭 이벤트 실행 안됨
  // event.preventDefault();
}
